import { PrimaryButton } from './styledComponents'
import type { ContinueButtonProps } from './types'


const ContinueButton = ({ handleClick, disabled = false }: ContinueButtonProps) => (
  <PrimaryButton id="continue-button" disabled={disabled} onClick={handleClick}>
    Continue
  </PrimaryButton>
)

ContinueButton.displayName = 'ContinueButton'

export { ContinueButton }
